import * as React from 'react';
import { styled } from '@mui/system';

const Root = styled('div')`
  table {
    font-family: arial, sans-serif;
    border-collapse: collapse;
    width: 100%;
  }

  td,
  th {
    border: 1px solid #ddd;
    text-align: left;
    padding: 8px;
  }
  th {
    background-color: #ddd;
  }
`;

const AogActivity = (props) => {

  const aogReport = props.activity;
  const activity = aogReport?.activity;

  return (
    <Root sx={{ maxWidth: '100%', minWidth: 500 }}>
      <table>
        <tbody>
        <tr>
          <td>Aircraft Defect:</td>
          <td>{aogReport?.aircraftDefect}</td>
        </tr>
        <tr>
          <td>Next Update:</td>
          <td>{aogReport?.nextUpdate}</td>
        </tr>
        <tr>
          <td>Estimated Recovery:</td>
          <td>{aogReport?.estimatedResolution ? aogReport.estimatedResolution : "N/A"}</td>
        </tr>
        <tr>
          <td>Estimated Departure:</td>
          <td>{aogReport?.estimatedDeparture ? aogReport.estimatedDeparture : "N/A"}</td>
        </tr>
        <tr>
          <td>Crew Status:</td>
          <td>{aogReport?.crewStatus}</td>
        </tr>
        </tbody>
      </table>

      <table>
        <thead>
        <tr>
          <th>Time Stamp</th>
          <th>Details</th>
        </tr>
        </thead>
        <tbody>
        {activity?.map((row) => (
          <tr key={row.timeStamp}>
            <td style={{ width: 160 }} align="left">
              {row.timeStamp}
            </td>
            <td style={{ width: 800 }} align="left">
              {row.details}
            </td>
          </tr>
        ))}
        </tbody>
      </table>
    </Root>
  );
}

export default AogActivity;
